import React from 'react';

import hyperloop from '../../imgs/hyperloop.jpg';


export default class Hyperloop2 extends React.Component {
  render() {
    return (
      <div className='typography-container'>

    <h1>Hyperloop</h1>
<p>
    В 2012 году Элон Маск – основатель SpaceX, Tesla Motors и SolarCity – заявил, что готов подарить миру концепцию пятого вида транспорта (после водного, воздушного, автомобильного и железнодорожного) – Hyperloop. Подробно свое видение системы он изложил в выпущенном в 2013 году специальном информационном документе. Однако, вместо того, чтобы заняться ее созданием самостоятельно, он выставил концепцию на открытую разработку.
</p>
<p>
    Hyperloop (Хайперлуп, «гиперпетля») — транспортная система, состоящая из множества сообщающихся труб, по которым в среде низкого давления будут с огромной скоростью (порядка 1200 км/ч), близкой к скорости звука, передвигаться капсулы-челноки, перевозя грузы и людей предельно быстро, очень дешево и безопасно на любые расстояния. Новое транспортное средство будет, по расчетам, вдвое быстрее самолета и в три-четыре раза быстрее скоростного поезда.
</p>
<p>
    Маск предложил построить между Сан-Франциско и Лос-Анджелесом (550 км) подземную или наземную трубу диаметром приблизительно в 2,2 метра, в которой в частичном вакууме (давление – 1/1000 атмосферного) капсулы из плотного алюминия перевозили бы людей на скоростях порядка 1000 км/ч – что достигалось бы, конечно, практически отсутствующим трением среды.
</p>
<p>
    Та часть воздуха, которая должна быть в трубе, втягивалась бы насосом на носу капсулы и передавалась бы под «лыжи» поезда – таким образом, капсула бы не касалась стенок трубы, левитируя над ее поверхностью.
</p>
<p>
    Движение и торможение самого поезда осуществлялось бы установленными на нем линейными электродвигателями.
</p>
<p>
    По задумке, капсулы в пределах системы смогут перемещаться с низкой и высокой скоростью при помощи сжатого воздуха и собственных аэродинамических свойств, разгоняясь посредством магнитных линейных ускорителей, расположенных на станциях.
</p>
<p>
    Система будет экологически чистой и исключительно энергоэффективной, полностью обеспечивая себя энергией за счет солнечныхпанелей, установленных на поверхности трубы. Этого количества энергии должно с запасом хватать для функционирования системы даже с учетом необходимости сохранения энергии в виде сжатого воздуха или другом виде для использования по ночам и в длительные периоды облачной погоды.
</p>
<p>
    Трубы Hyperloop предполагается по всей длине установить на достаточно гибко укрепленных столбах, таким образом решив две проблемы: свободного места и покупки земли, а также непрерывного слабого перемещения земной коры.
</p>
<p>
    Для мгновенного отслеживания неполадок компания-разработчик Hyperloop One предложила использовать специально созданный углеродный материал, снабженный сенсорами, который они назвали вибраниум.
</p>
<p>
  Первые коммерческие перевозки в пределах штата Калифорния запланированы на конец 2018 — начало 2019 года.

Ожидаемые характеристики поезда Hyperloop (согласно заявлениям Илон Маска):
</p>

<ul>
    <li>
        будет в 2 раза быстрее самолёта и в 3-4 раза быстрее скоростного
        поезда, время в пути от Лос-Анджелеса до Сан-Франциско (расстояние 561
        км по прямой) займёт всего 30 минут.
    </li>
    <li>
        проект окажется в 10 раз дешевле по сравнению с California High-Speed
        Rail;
    </li>
    <li>
        транспорт не будет подвержен авариям;
    </li>
    <li>
        дорога должна работать от солнечной энергии;
    </li>
    <li>
        пассажирам не придётся подстраиваться к расписанию, ибо транспортные
        капсулы будут двигаться с короткими интервалами, как в метро;
    </li>
    <li>
        все спецификации окажутся в свободном доступе.
    </li>
</ul>
<p>
    Одним из проектов вакуумного поезда также является трансатлантический
    подводный поезд Великобритания-США на основе магнитной левитации, правда,
    проект пока что находится на стадии самого раннего концепта.
</p>
<p>
    При переносе на российскую географию это говорит о том, что Hyperloop
    домчал бы пассажиров из Москвы в Санкт-Петербург примерно за 40 минут, что,
    конечно, стало бы воплощением мечтаний очень и очень многих.
</p>
  <p align='center'>
      <img className='responsive-img' alt='hyperloop' src={hyperloop} />
  </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Hyperloop-2.js